<template>
  <div id="data-list-list-view" class="data-list-container py-6">
    <div class="flex justify-between items-center space-x-8 mb-8 border-b pb-4">
      <div>
        <h4 class="text-lg mr-4 leading-none font-semibol">
          {{ $t('components.customer.profile.products.history') }}
        </h4>
      </div>
    </div>
    <div class="flex flex-col divide-y overflow-hidden p-2 md:p-2 items-center h-full bg-white dark:bg-gray-800/20 dark:border dark:border-gray-800 shadow-lg rounded-2xl mb-4">
      <product
        v-for="product in products"
        :key="product.idOrderItem"
        :product="product"
        class="w-full"
      />

      <p v-if="products.length === 0" class="p-4 text-sm opacity-60">
        {{ $t('components.customer.profile.products.empty') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import Product from './product.vue'

import {
  OStatistic,
} from '@/components/elements'

interface Props {
  customer?: Record<string, any> | null
}

const props = withDefaults(defineProps<Props>(), {
  customer: null,
})

const { $api } = useNuxtApp()

const selected = ref<any[]>([])
const products = ref<any[]>([])

const fetchProducts = async () => {
  try {
    const result = await ($api as any).customer.productHistory(props.customer!.idCustomer)

    products.value = result.items
  } catch (e) {
    console.log(e)
  }
}

// created
fetchProducts()
</script>
